import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Field } from "./vforms-model";

@Injectable()
export class DragStylingService {
    isDragging$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    onEditorDragging$: BehaviorSubject<Field> = new BehaviorSubject<Field>(undefined);

    constructor() {}
}
